/* eslint-disable */
import { produce } from "immer";
import {
  LEARN_LANDING_FAQ_FETCH_FAILURE,
  LEARN_LANDING_FAQ_FETCH_SUCCESS,
  LEARN_LANDING_FAQ_FETCH_START,
} from "../actions/types";

const learnFaq = (
  state = {
    faqFetching: false,
    faqData: [],
    faqError: null,
  },
  action,
) => {
  switch (action.type) {
    case LEARN_LANDING_FAQ_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case LEARN_LANDING_FAQ_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case LEARN_LANDING_FAQ_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default learnFaq;
